import React, { useState } from "react";
import PropTypes from "prop-types";

function SendInput({
  onSend,
  placeholder = "What's on your mind?",
  disabled = false,
  isSending = false,
  className = "",
}) {
  const [text, setText] = useState("");

  const handleSend = (e) => {
    e.preventDefault();
    if (!text.trim() || disabled || isSending) return;

    if (onSend) {
      onSend(text.trim());
    }
    setText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent Enter from sending via form submit
    }
  };

  return (
    <form onSubmit={handleSend} className={`comment-input-form ${className}`}>
      <input
        type="text"
        className="comment-input-field"
        placeholder={placeholder}
        value={text}
        onChange={(e) => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled || isSending}
      />
      <button
        type="submit"
        disabled={!text.trim() || disabled || isSending}
        aria-label="Send"
        className="comment-send-button"
      >
        <img
          src={`${process.env.PUBLIC_URL}/images/icons/send_white.svg`}
          alt="Send"
          className="comment-send-icon"
        />
      </button>
    </form>
  );
}

SendInput.propTypes = {
  onSend: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isSending: PropTypes.bool,
  className: PropTypes.string,
};

export default SendInput;
